export const images = {
  home: {
    header: "/images/Home-Banner.jpg",
    footer: "/images/Home-Banner-Footer.jpg",
  },
  contact: {
    header: "/images/ContactUs-Banner-New.jpg",
    side: "/images/Contact-Side-New.jpg",
  },
}
